export function PrivacyTerms() {
  return (
    <div className="prose max-w-3xl mx-auto py-12 px-4">
      <h1>개인정보 수집 및 이용 동의</h1>
      <h2>1. 수집 항목 및 방법</h2>
      <p>이메일 주소, 닉네임, 사용자 유형, 소셜 로그인 정보 등을 회원가입 시 수집합니다.</p>

      <h2>2. 이용 목적</h2>
      <ul>
        <li>회원 식별 및 인증</li>
        <li>게시판 이용, 등업 심사 등 커뮤니티 운영</li>
        <li>고객 응대 및 분쟁 조정을 위한 기록 보관</li>
      </ul>

      <h2>3. 보유 및 이용 기간</h2>
      <p>회원 탈퇴 시 즉시 파기되며, 법령에 따라 필요한 경우 일정 기간 보관됩니다.</p>

      <h2>4. 동의 거부 권리</h2>
      <p>
        사용자는 개인정보 수집 및 이용에 동의하지 않을 권리가 있으며,
        단, 필수 항목에 대한 동의 없이는 서비스 가입이 제한됩니다.
      </p>

      <h2>5. 추가 수집 항목 (정회원 등업 시)</h2>
      <p>회원의 유형에 따라 A-Blind의 정회원(등업) 신청 시 다음과 같은 추가 정보를 수집할 수 있습니다:
</p>
<ul>
  <li><strong>예술가(artist)</strong>: 포트폴리오, 전시 이력, 소속 정보 등</li>
  <li><strong>예술 종사자(worker)</strong>: 명함, 기관 재직 확인 자료, 직무 관련 정보 등</li>
  <li><strong>예술 애호가(fan)</strong>: 전시 관람 이력, 작품 소장 사진, 감상 후기 등의 자료</li>

</ul>
<p>
  해당 정보는 커뮤니티 내 신뢰 기반 운영과 서비스 제공을 위한 목적 외에는 사용되지 않으며, 등업 처리 이후 즉시 파기됩니다.
</p>
    </div>
  );
}